import { GET_DASH_PATIENTS_DETAILS, GET_DASH_PATIENTS_DETAILS_LOADING, GET_DASH_PATIENTS_DETAILS_RET } from "../Constants"

export const getDashPatientDetails = (data) => {
    return {
        type: GET_DASH_PATIENTS_DETAILS,
        data
    }
}

export const getDashPatientDetailsRet = (data) => {
    return {
        type: GET_DASH_PATIENTS_DETAILS_RET,
        data
    }
}

export const getDashPatientDetailsLoading = (data) => {
    return {
        type: GET_DASH_PATIENTS_DETAILS_LOADING,
        data
    }
}
